import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

export const element = createSlice({
  name: "ui",
  initialState: {
    lang: "en",
    theme: "rog",
    platform: "armoury_crate",
    privacyNotificationDialogId: "privacyNotificationDialog",
    submitDialogId: "submitDialog",
    errorDialogId: "errorDialog",
    isShowErrorDialog: false,
    isShowSubmitDialog: false,
    isShowPrivacyNotificationDialog: false,
    isPrivacyNotificationContentFocused: false,
    reportCodeDialogId: "reportCodeDialog",
    reportCodeMode: 0, // 0: show report code input, 1: show report code result
    reportCode: "",
    isShowReportCodeDialog: false,
    isShowSelect: false,
    focusNameList: ["email", "first_category", "description"],
    focusIndex: 0,
    isFocus: false,
    enableRootKeyboardEvent: true,
    selectedLikeType: null,
  },
  reducers: {
    init: (state) => {
      state.selectedLikeType = null;
      state.lang = "en";
      state.theme = "rog";
      state.enableRootKeyboardEvent = true;
      state.isShowErrorDialog = false;
      state.isShowSubmitDialog = false;
      state.isShowPrivacyNotificationDialog = false;
      state.isPrivacyNotificationContentFocused = false;
      state.focusNameList = ["email", "first_category", "description"];
      state.focusIndex = 0;
      state.isFocus = false;
      state.isShowReportCodeDialog = false;
      state.reportCodeMode = 0;
      state.reportCode = "";
      state.isShowSelect = false;
    },
    setIsFocus: (state, action) => {
      state.isFocus = action.payload;
    },
    nextFocusIndex: (state) => {
      state.focusIndex = state.focusIndex + 1;
    },
    setFocusIndex: (state, action) => {
      state.focusIndex = action.payload;
    },
    setEnableRootKeyboardEvent: (state, action) => {
      state.enableRootKeyboardEvent = action.payload;
    },
    initFocusNameList: (state) => {
      state.focusNameList = ["email", "first_category", "description"];
    },
    setFocusNameList: (state, action) => {
      state.focusNameList = action.payload;
    },
    setLang: (state, action) => {
      state.lang = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setDocument: (state, action) => {
      state.document = action.payload;
    },
    triggerPrivacyNotificationDialog: (state, action) => {
      state.isShowPrivacyNotificationDialog = action.payload;
    },
    setPrivacyNotificationContentFocused: (state, action) => {
      state.isPrivacyNotificationContentFocused = action.payload;
    },
    triggerReportCodeDialog: (state, action) => {
      state.isShowReportCodeDialog = action.payload;
    },
    setReportCode: (state, action) => {
      state.reportCode = action.payload;
    },
    setReportCodeMode: (state, action) => {
      state.reportCodeMode = action.payload;
    },
    triggerSubmitDialog: (state, action) => {
      state.isShowSubmitDialog = action.payload;
    },
    triggerErrorDialog: (state, action) => {
      state.isShowErrorDialog = action.payload;
    },
    triggerDialog: (state, action) => {
      const { id, isOpen } = action.payload;
      switch (id) {
        case state.privacyNotificationDialogId:
          console.log("trigger privacy dialog", isOpen);
          state.isShowPrivacyNotificationDialog = isOpen;
          break;
        case state.submitDialogId:
          state.isShowSubmitDialog = isOpen;
          break;
        case state.errorDialogId:
          state.isShowErrorDialog = isOpen;
          break;
        case state.reportCodeDialogId:
          state.isShowReportCodeDialog = isOpen;
        default:
          break;
      }
    },
    setSelectedLikeType: (state, action) => {
      state.selectedLikeType = action.payload;
    },
    setIsShowSelect: (state, action) => {
      state.isShowSelect = action.payload;
    },
  },
  extraReducers: (builder) => {
    // builder.addCase('feedback/setAgreePrivacyPolicy', (state, action) => {
    //   state.isShowPrivacyNotificationDialog = false
    // })
  },
});

export default element.reducer;
